'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.connect = undefined;

var _reactRedux = require('react-redux');

var _pipe = require('ramda/src/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _reduce = require('ramda/src/reduce');

var _reduce2 = _interopRequireDefault(_reduce);

var _when = require('ramda/src/when');

var _when2 = _interopRequireDefault(_when);

var _isPlainObject = require('is-plain-object');

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var connect = exports.connect = function connect(connector) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return _reactRedux.connect.apply(undefined, [(0, _when2.default)(_isPlainObject2.default, function (defs) {
    return function (state, props) {
      var reducer = function reducer(obj, key) {
        obj[key] = defs[key](state, props);
        return obj;
      };

      return (0, _pipe2.default)(Object.keys, (0, _reduce2.default)(reducer, {}))(defs);
    };
  })(connector)].concat(args));
};